'use client';

import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { FaCalendarAlt, FaClock, FaFacebookF, FaLinkedinIn, FaTwitter, FaUser, FaWhatsapp } from 'react-icons/fa';

import Breadcrumb from '@/components/Breadcrumb';
import Header from '@/components/Header';


export default function BotoksFiyatlari2026Page() {
  const pageUrl = typeof window !== 'undefined' ? window.location.href : 'https://drbariscin.com/tr/blog/botoks-fiyatlari-2026';
  const pageTitle = 'Botoks Fiyatları 2026: Güncel Ücretler ve Etki Faktörleri';

  const handleShare = (platform: string) => {
    let shareUrl = '';
    
    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(pageTitle)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageUrl)}`;
        break;
      case 'whatsapp':
        shareUrl = `https://wa.me/?text=${encodeURIComponent(pageTitle + ' - ' + pageUrl)}`;
        break;
      default:
        return;
    }
    
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        {/* Breadcrumb */}
        <div className="mb-8">
          <Breadcrumb
            items={[
              { label: 'Ana Sayfa', href: '/tr' },
              { label: 'Blog', href: '/tr/blog' },
              { label: 'Botoks Fiyatları 2026', href: '/tr/blog/botoks-fiyatlari-2026' },
            ]}
          />
        </div>

        {/* Article Header */}
        <article className="bg-white rounded-3xl shadow-xl overflow-hidden">
          {/* Featured Image */}
          <div className="relative h-64 sm:h-80">
            <Image
              src="/images/terleme-tedavisi.webp"
              alt="Botoks uygulaması"
              fill
              className="object-cover"
              priority
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <div className="absolute bottom-6 left-6">
              <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                Estetik Tedaviler
              </span>
            </div>
          </div>

          {/* Article Content */}
          <div className="p-6 sm:p-8">
            {/* Title */}
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Botoks Fiyatları 2026: Güncel Ücretler ve Etki Faktörleri
            </h1>

            {/* Meta Information */}
            <div className="flex flex-wrap items-center gap-6 mb-8 text-sm text-gray-600 border-b border-gray-200 pb-6">
              <div className="flex items-center">
                <FaUser className="w-4 h-4 mr-2" />
                <span>Op. Dr. Barış Çin</span>
              </div>
              <div className="flex items-center">
                <FaCalendarAlt className="w-4 h-4 mr-2" />
                <span>15 Ocak 2026</span>
              </div>
              <div className="flex items-center">
                <FaClock className="w-4 h-4 mr-2" />
                <span>8 dakika okuma</span>
              </div>
            </div>

            {/* Share Buttons */}
            <div className="flex items-center gap-4 mb-8">
              <span className="text-gray-600 font-medium">Paylaş:</span>
              <div className="flex gap-3">
                <button className="p-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors" onClick={() => handleShare('facebook')}>
                  <FaFacebookF className="w-4 h-4" />
                </button>
                <button className="p-2 bg-blue-400 text-white rounded-full hover:bg-blue-500 transition-colors" onClick={() => handleShare('twitter')}>
                  <FaTwitter className="w-4 h-4" />
                </button>
                <button className="p-2 bg-blue-700 text-white rounded-full hover:bg-blue-800 transition-colors" onClick={() => handleShare('linkedin')}>
                  <FaLinkedinIn className="w-4 h-4" />
                </button>
                <button className="p-2 bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors" onClick={() => handleShare('whatsapp')}>
                  <FaWhatsapp className="w-4 h-4" />
                </button>
              </div>
            </div>

            {/* Article Content */}
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Botulinum toksin tedavisi, 2026 yılında hem estetik hem de tıbbi alanlarda yoğun talep görmeye devam etmektedir. Yüz gençleştirme uygulamaları arasında en sık tercih edilen bu minimal invaziv yöntem, kırışıklıkların azaltılmasından kas spazmlarının tedavisine kadar geniş bir kullanım alanına sahiptir. Ancak botoks fiyatları 2026 yılı itibarıyla pek çok etkene bağlı olarak farklılık göstermektedir.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Botoks Tedavisinde Fiyatları Belirleyen Kriterler
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Günümüzde botulinum toksin uygulamalarının ücretleri yalnızca bölgeye göre değil, aynı zamanda birçok klinik ve hasta özel faktöre bağlıdır:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li><strong>Uygulama Alanı Genişliği:</strong> Hedeflenen kas grubu ve enjeksiyon noktalarının sayısı.</li>
                <li><strong>Marka ve Ürün Kalitesi:</strong> Botox®, Dysport®, Xeomin® gibi markaların fiyat farkları.</li>
                <li><strong>Hekimin Uzmanlığı:</strong> Alanında deneyimli estetik cerrah ve dermatologların ücret politikası.</li>
                <li><strong>Muayenehane Donanımı:</strong> Kullanılan teknoloji ve sterilizasyon sistemleri.</li>
                <li><strong>Takip ve Kontrol Hizmetleri:</strong> Uygulama sonrası planlanan değerlendirme seansları.</li>
              </ul>
              <p className="text-gray-700 mb-6 leading-relaxed">
                2026 yılı için seans başına 132,8 €  den başlıyan fiyatlar gözlemlenmektedir.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Botulinum Toksin Uygulaması Nedir?
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Botulinum toksin, nöromüsküler iletiyi geçici olarak bloke eden bir nörotoksindir. Sinir uçlarından kasa iletilen sinyalleri durdurarak hedef kas grubunun geçici olarak gevşemesini sağlar. Bu mekanizma sayesinde hem estetik amaçlı kırışıklıkların görünümü azalır hem de tıbbi bazı kas hastalıklarında spazm ve sertlik kontrol altına alınabilir.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Fizik Tedavide Botulinum Toksin Enjeksiyonu
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Medikal rehabilitasyon protokollerinde sıkça kullanılan bu uygulama, özellikle spastik felç, serebral palsi, distoni ve kas kontraktürleri gibi durumlarda büyük fayda sağlamaktadır:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                <li><strong>Ultrason veya EMG Eşliğinde Uygulama:</strong> Hedef kasın tam lokalizasyonu yapılır.</li>
                <li><strong>Doz Kişiye Özel Belirlenir:</strong> Spastisite şiddeti ve kas kitlesine göre doz ayarlanır.</li>
                <li><strong>Rehabilitasyon Desteklenir:</strong> Enjeksiyon sonrası fizik tedavi programları uygulanır.</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Kasılmada Botoks Tedavisi: Kas Gevşetici Etki
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                İstem dışı kasılmalar (spazmlar) ve kronik kas sertliklerinde kaslara uygulanan botulinum toksin tedavisi yaşam kalitesini önemli ölçüde artırır. Özellikle:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>Bruksizm (Diş sıkma)</li>
                <li>Servikal distoni (Boyun kası spazmları)</li>
                <li>Serebral palsi kaynaklı spastisite</li>
              </ul>
              <p className="text-gray-700 mb-6 leading-relaxed">
                gibi durumlarda yaygın kullanım alanı bulur.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Hangi Vücut Bölgelerine Uygulanabilir?
              </h2>
              <div className="bg-blue-50 rounded-xl p-6 mb-6">
                <ul className="list-disc list-inside text-blue-800 space-y-2">
                  <li>Alın çizgileri (frontal kırışıklıklar)</li>
                  <li>Kaş arası çizgileri (glabella çizgileri)</li>
                  <li>Göz çevresi kaz ayakları</li>
                  <li>Çene (masseter kası)</li>
                  <li>Boyun bantları (platysma)</li>
                  <li>Burun üstü çizgileri (bunny lines)</li>
                  <li>Aşırı terleme bölgeleri (koltuk altı, avuç içi, ayak tabanı)</li>
                </ul>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Burun Üzerinde Botoks Uygulaması
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Burun bölgesinde botulinum toksin uygulaması özellikle iki estetik probleme çözüm sunar:
              </p>
              
              <div className="bg-green-50 rounded-xl p-6 mb-4">
                <h3 className="text-lg font-semibold text-green-900 mb-3">🔹 Bunny Lines (Burun Üstü Çizgiler):</h3>
                <p className="text-green-800">
                  Gülme sırasında burun sırtında oluşan yatay ve çapraz çizgiler, zamanla kalıcı hale gelebilir. Botulinum toksin enjeksiyonu ile bu kasların (nasalis kası) geçici olarak gevşetilmesi sağlanır. Böylece çizgiler belirgin şekilde azalır.
                </p>
              </div>

              <div className="bg-green-50 rounded-xl p-6 mb-4">
                <h3 className="text-lg font-semibold text-green-900 mb-3">🔹 Burun Ucu Sarkması:</h3>
                <p className="text-green-800">
                  Bazı kişilerde konuşma veya gülme sırasında burun ucu aşağıya doğru hareket edebilir. Burun tabanındaki depressor septi nasi kasına uygulanan minimal doz botoks ile burun ucunun düşmesi engellenebilir. Özellikle ameliyat gerektirmeden burun estetiğinde küçük dokunuş isteyen hastalar için oldukça popüler bir uygulamadır.
                </p>
              </div>

              <div className="bg-green-50 rounded-xl p-6 mb-6">
                <h3 className="text-lg font-semibold text-green-900 mb-3">🔹 Burun Estetiği Sonrası Destek:</h3>
                <p className="text-green-800">
                  Rinoplasti sonrası iyileşme sürecinde bazı hastalarda burun kas aktivitesini dengelemek amacıyla da uygulanabilir.
                </p>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-8">
                <p className="text-sm text-yellow-700">
                  <strong>📝 Not:</strong> Burun bölgesi oldukça hassas olduğundan doz ayarı ve enjeksiyon tekniği yüksek uzmanlık gerektirir.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                2026 Güncel Ortalama Fiyatlar
              </h2>

              {/* Price Table */}
              <div className="overflow-x-auto mb-8">
                <table className="w-full bg-white border border-gray-300 rounded-lg">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Uygulama Bölgesi
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Ortalama Fiyat (TL)
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">Botoks</td>
                      <td className="px-6 py-4 text-sm text-gray-900 font-semibold">132,8 € den başlıyan fiyatlar ile</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="px-6 py-4 text-sm text-gray-900">Dudak Dolgusu</td>
                      <td className="px-6 py-4 text-sm text-gray-900 font-semibold">132,8 € den başlıyan fiyatlar ile</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">Kalsiyum Hidroksiapatit Dolgu</td>
                      <td className="px-6 py-4 text-sm text-gray-900 font-semibold">306,4 € den başlıyan fiyatlar ile</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="px-6 py-4 text-sm text-gray-900">Hyaluronik Asit Dolgu</td>
                      <td className="px-6 py-4 text-sm text-gray-900 font-semibold">132,8 € den başlıyan fiyatlar ile</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">Botoks Terleme Tedavisi</td>
                      <td className="px-6 py-4 text-sm text-gray-900 font-semibold">388,0 – 418,8 €</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="px-6 py-4 text-sm text-gray-900">Mezoterapi</td>
                      <td className="px-6 py-4 text-sm text-gray-900 font-semibold">173,6 – 204,1 €</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-900">Masseter Botoks</td>
                      <td className="px-6 py-4 text-sm text-gray-900 font-semibold">173,6 – 204,1 €</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Alın Bölgesi Enjeksiyonu
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Alın botoksu, mimik hareketleri sırasında alın bölgesinde ortaya çıkan yatay çizgilerin yumuşatılmasını sağlar. Frontal kasın kontrolsüz kasılması zamanla kırışıklıkların derinleşmesine neden olur.
              </p>
              
              <div className="bg-purple-50 rounded-xl p-6 mb-4">
                <h3 className="text-lg font-semibold text-purple-900 mb-3">Uygulamanın Temel Hedefleri:</h3>
                <ul className="list-disc list-inside text-purple-800 space-y-2">
                  <li>Dinamik kırışıklıkları azaltmak</li>
                  <li>Önleyici etki sağlamak (profilaktik botoks)</li>
                  <li>Aşırı mimik kullanımını dengelemek</li>
                </ul>
              </div>

              <div className="bg-purple-50 rounded-xl p-6 mb-6">
                <h3 className="text-lg font-semibold text-purple-900 mb-3">Doz ve Nokta Seçimi:</h3>
                <ul className="list-disc list-inside text-purple-800 space-y-2">
                  <li>Dozaj kişiye özel planlanır.</li>
                  <li>Gereğinden fazla doz uygulanması durumunda donuk yüz ifadesi oluşabilir.</li>
                  <li>Gereğinden az doz uygulanması yetersiz etki yaratabilir.</li>
                  <li><strong>İdeal sonuç:</strong> Doğal mimiklerin korunarak pürüzsüz bir alın görünümü sağlanmasıdır.</li>
                </ul>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Çene Botoksu: Masseter Kasına Uygulama
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Çene botoksu, masseter kasının hacmini küçültmek ve aşırı kas aktivitesini dengelemek amacıyla uygulanır. Bu sayede:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>Diş sıkma alışkanlığı azalır.</li>
                <li>Çene ağrıları hafifler.</li>
                <li>Yüz ovali incelir ve daha estetik bir kontur oluşur.</li>
              </ul>
              
              <div className="bg-orange-50 rounded-xl p-6 mb-6">
                <h3 className="text-lg font-semibold text-orange-900 mb-3">Uygulama Sonrası:</h3>
                <p className="text-orange-800">
                  🔹 İlk gün sert gıdalardan kaçınmak, çene kaslarını fazla zorlamamak önerilir.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Uygulama Öncesi ve Sonrası Tavsiyeler
              </h2>
              
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-red-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-red-900 mb-3">Uygulama Öncesi:</h3>
                  <ul className="list-disc list-inside text-red-800 space-y-2">
                    <li>Kan sulandırıcı ilaçlar bırakılmalı.</li>
                    <li>Alkol ve kafein tüketimi sınırlanmalı.</li>
                    <li>Cilt enfeksiyonu varsa tedavi tamamlanmalı.</li>
                  </ul>
                </div>

                <div className="bg-green-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-green-900 mb-3">Uygulama Sonrası:</h3>
                  <ul className="list-disc list-inside text-green-800 space-y-2">
                    <li>İlk 24-48 saat yüz masajı ve sıcak ortamdan kaçınılmalı.</li>
                    <li>Botoks sonrası duş alınabilir, ancak sıcak su ve buhar önerilmez.</li>
                    <li>Baş pozisyonu ilk gün yüksek tutulmalı.</li>
                    <li>Yoğun spor ve ağır egzersiz 2 gün ertelenmeli.</li>
                  </ul>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Botox Etkisini Kaç Günde Gösterir?
              </h2>
              <div className="bg-blue-50 rounded-xl p-6 mb-6">
                <ul className="list-disc list-inside text-blue-800 space-y-2">
                  <li><strong>İlk Etki:</strong> 3-5 gün içerisinde başlar.</li>
                  <li><strong>Maksimum Etki:</strong> 10-14 gün sonra görülür.</li>
                  <li><strong>Etki Süresi:</strong> Ortalama 4-6 ay boyunca devam eder.</li>
                </ul>
                <p className="text-blue-800 mt-3">
                  Düzenli uygulamalarda kas hafızası gelişerek daha uzun süreli sonuçlar alınabilir.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Göz Çevresinde Botulinum Toksin Etkisi
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Göz çevresi kırışıklıkları (kaz ayakları), özellikle yaşlanmanın en erken fark edilen belirtilerindendir. Orbikularis oculi kasının aşırı kasılmasıyla oluşan bu çizgiler zamanla kalıcı hale gelir.
              </p>
              
              <div className="bg-indigo-50 rounded-xl p-6 mb-4">
                <h3 className="text-lg font-semibold text-indigo-900 mb-3">Tedavi Hedefleri:</h3>
                <ul className="list-disc list-inside text-indigo-800 space-y-2">
                  <li>Gülüş esnasında ortaya çıkan kaz ayaklarını azaltmak</li>
                  <li>Göz çevresine doğal ışıltı ve dinlenmiş görünüm kazandırmak</li>
                  <li>Göz kapağı düşüklüğü (ptozis) riskini önlemek</li>
                </ul>
              </div>

              <div className="bg-indigo-50 rounded-xl p-6 mb-6">
                <h3 className="text-lg font-semibold text-indigo-900 mb-3">Özel Hususlar:</h3>
                <ul className="list-disc list-inside text-indigo-800 space-y-2">
                  <li>Bu bölge yüz sinirine çok yakın olduğu için enjeksiyon noktaları hassas şekilde planlanmalıdır.</li>
                  <li>Simetri korunması için her iki göz çevresine dengeli doz uygulanmalıdır.</li>
                  <li>Aşırı doz, donuk bakış görünümüne yol açabilir.</li>
                </ul>
                <p className="text-indigo-800 mt-3">
                  🔹 <strong>Deneyimli ellerde uygulandığında doğal, enerjik ve genç bir ifade kazandırır.</strong>
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Sıkça Sorulan Sorular (FAQ)
              </h2>

              <div className="space-y-6 mb-8">
                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">1. Botulinum toksin kalıcı mıdır?</h3>
                  <p className="text-gray-700">🔹 Hayır. Etkisi geçici olup 4-6 ay sürer.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">2. Etki süresi kişiye göre değişir mi?</h3>
                  <p className="text-gray-700">🔹 Evet. Kas yapısı, mimik alışkanlıkları ve metabolizma hızı etki süresini etkiler.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">3. İlk kez yaptıranlarda doz farkı olur mu?</h3>
                  <p className="text-gray-700">🔹 Genellikle başlangıçta daha düşük doz uygulanarak sonuç değerlendirilir.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">4. Hangi yaşta başlanmalıdır?</h3>
                  <p className="text-gray-700">🔹 25 yaş sonrası, kırışıklıkların başlangıcında profilaktik amaçla başlanabilir.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">5. Botulinum toksin zararlı mı?</h3>
                  <p className="text-gray-700">🔹 FDA onaylı dozlarda uzman ellerde güvenlidir. Yanlış uygulamalar risklidir.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">6. Botulinum toksin bağımlılık yapar mı?</h3>
                  <p className="text-gray-700">🔹 Hayır. Fiziksel bağımlılık yapmaz. Ancak estetik memnuniyet nedeniyle düzenli yaptırılabilir.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">7. İşlem sırasında ağrı olur mu?</h3>
                  <p className="text-gray-700">🔹 İğneler çok incedir. Genelde kısa süreli batma hissi dışında ağrı hissedilmez.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">8. Yan etkileri nelerdir?</h3>
                  <p className="text-gray-700">🔹 Geçici şişlik, kızarıklık, morarma ve nadiren geçici asimetri oluşabilir.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">9. Göz kapağı düşüklüğü riski nedir?</h3>
                  <p className="text-gray-700">🔹 Uygun teknikle çok düşük; yanlış noktalara enjeksiyon yapılırsa geçici ptozis görülebilir.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">10. Hamilelikte uygulanabilir mi?</h3>
                  <p className="text-gray-700">🔹 Hamile ve emziren kadınlarda uygulanmaz.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">11. Botoks sonrası duş ne zaman alınmalı?</h3>
                  <p className="text-gray-700">🔹 İlk 24 saat sıcak duş, sauna ve buhar banyosu önerilmez; ılık duş alınabilir.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">12. Spor ne zaman yapılabilir?</h3>
                  <p className="text-gray-700">🔹 İlk 48 saat ağır egzersiz yapılmamalıdır.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">13. Etkiyi uzatmak için ne yapılabilir?</h3>
                  <p className="text-gray-700">🔹 Düzenli uygulamalarla kas hafızası gelişir ve süre uzar.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">14. Alın botoksu sonrası baş ağrısı olur mu?</h3>
                  <p className="text-gray-700">🔹 Nadiren, kısa süreli geçici baş ağrısı olabilir.</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-2">15. Göz çevresine uygulama sonrası göz sağlığı etkilenir mi?</h3>
                  <p className="text-gray-700">🔹 Uygun doz ve teknikle göz fonksiyonları korunur, görme üzerinde kalıcı etkisi yoktur.</p>
                </div>
              </div>

              <div className="bg-green-50 border-l-4 border-green-400 p-4 mb-8">
                <p className="text-sm text-green-700">
                  🔹 <strong>Bilimsel verilere göre uzun vadeli kontrollü kullanımda ciddi zarar bildirilmemiştir.</strong>
                </p>
              </div>

              {/* Image placeholder for article */}
              <div className="relative h-64 rounded-xl overflow-hidden mb-8">
                <Image
                  src="/images/terleme-tedavisi.webp"
                  alt="Alın botoksu uygulaması"
                  fill
                  className="object-cover"
                />
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
                Kaynakça
              </h2>
              <div className="bg-gray-50 rounded-xl p-6 mb-8">
                <ul className="list-disc list-inside text-gray-700 space-y-3">
                  <li><strong>1️⃣ American Academy of Dermatology (AAD)</strong> – Botulinum Toxin Guidelines</li>
                  <li><strong>2️⃣ Türkiye Estetik Plastik Cerrahi Derneği (TEPCD)</strong> – Botulinum Toksin Kullanım Kılavuzu</li>
                  <li><strong>3️⃣ Mayo Clinic</strong> – Botulinum Toxin Medical Use</li>
                  <li><strong>4️⃣ FDA</strong> – Botulinum Toxin Type A Onay Belgeleri</li>
                  <li><strong>5️⃣ International Society of Aesthetic Plastic Surgery (ISAPS)</strong> – 2024 Global Aesthetic Statistics</li>
                </ul>
              </div>
            </div>

            {/* Call to Action */}
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white text-center mt-12">
              <h3 className="text-2xl font-bold mb-4">Botoks Uygulaması İçin Randevu Alın</h3>
              <p className="mb-6">Uzman doktorumuzdan detaylı bilgi alın ve size özel fiyat teklifi için hemen iletişime geçin.</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  href={`https://wa.me/905438999586?text=${encodeURIComponent('Botoks uygulaması hakkında bilgi almak istiyorum.')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-6 py-3 bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors"
                >
                  <FaWhatsapp className="w-5 h-5 mr-2" />
                  WhatsApp ile İletişim
                </Link>
                <Link
                  href="/tr/iletisim"
                  className="inline-flex items-center justify-center px-6 py-3 bg-white text-blue-600 rounded-full hover:bg-gray-100 transition-colors"
                >
                  Randevu Al
                </Link>
              </div>
            </div>
          </div>
        </article>

        {/* Related Articles */}
        <div className="mt-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">İlgili Yazılar</h3>
          <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
            <p className="text-gray-600 mb-4">
              Yakında daha fazla bilgilendirici içerik ile burada olacağız.
            </p>
            <Link
              href="/tr/blog"
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors"
            >
              Tüm Blog Yazılarını Görüntüle
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
} 